export default __webpack_public_path__ + "static/media/Vectorlinkedin.5fccd5c3.svg";